import { css, styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

const error = ({ $error }: { $error?: unknown }) =>
  $error
    ? css`
        border-color: ${(props) => props.theme.colours.error};
        background-color: #f7ebeb;

        &:hover {
          border-color: ${(props) => props.theme.colours.error};
        }

        &:focus {
          border-color: ${(props) => props.theme.colours.error};
        }
      `
    : css``;

export const Textarea = styled.textarea<{ name: string; $error?: unknown }>`
  ${typeScale.md}

  width: 100%;
  display: block;
  padding: 0.5rem 0.75rem;
  color: ${(props) => props.theme.colours.grey[900]};
  background: ${(props) => props.theme.colours.grey[50]};
  border: 1px solid ${(props) => props.theme.colours.grey[400]};
  border-radius: 6px;
  transition: all 200ms ease-in-out;

  &:hover {
    border-color: ${(props) => props.theme.colours.grey[600]};
  }

  &:focus {
    border-color: ${(props) => props.theme.colours.grey[600]};
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colours.focus};
  }

  ${error}
`;
